// extracted by mini-css-extract-plugin
export default {"spinner__wrapper":"LoadingSpinner_spinner__wrapper__S-4DM","spinner":"LoadingSpinner_spinner__iCCKL"};